import React from 'react'

import {
  Box,
  Display,
  DisplayPosition,
  FontFamily,
  FontWeight,
  Text,
} from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { DietaryBadge } from '../RecipeTile.styles'

type DietaryBadgeRowProps = {
  recipe: StandardRecipeItem
}

export const DietaryBadgeRow = ({ recipe }: DietaryBadgeRowProps) => {
  const tags = recipe.tagGroups.dietary ?? []

  if (tags.length === 0) {
    return null
  }

  return (
    <Box
      data-testid="recipe-tile-dietary-tags"
      display={Display.Flex}
      gap={1}
      position={DisplayPosition.Absolute}
      style={{ top: '1rem', left: '1rem', zIndex: 2 }}
    >
      {tags.map((tag) => (
        <DietaryBadge key={tag.type}>
          <Text
            size={2}
            fontFamily={FontFamily.Bold}
            fontWeight={FontWeight.Bold}
            style={{ color: 'inherit', lineHeight: '1' }}
          >
            {tag.text}
          </Text>
        </DietaryBadge>
      ))}
    </Box>
  )
}
